import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
const BOOK_CLUB_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB;
export const getSubscriptionVariantBenefits = (subscription) => {
    const benefitsContent = getComponentContentById(subscription.components, BOOK_CLUB_IDS.VARIANT.BENEFITS.ID);
    if (!benefitsContent || !benefitsContent.chunks.length)
        return [];
    if (benefitsContent.__typename !== "ContentChunkContent")
        return [];
    return benefitsContent.chunks
        .flatMap((chunk) => chunk
        .filter(({ componentId }) => componentId === BOOK_CLUB_IDS.VARIANT.BENEFITS.BENEFIT)
        .map(({ content }) => content?.__typename === "SingleLineContent"
        ? content.text?.trim()
        : undefined))
        .filter((benefit) => Boolean(benefit));
};
